import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../components/PageShell.jsx';
import LeadForm from '../components/LeadForm.jsx';
import Seo from '../components/Seo.jsx';
import { getLegalPage } from '../content/index.js';

function LegalSection({ section }) {
  return (
    <section className="legal-block">
      <h2>{section.heading}</h2>
      {(section.paragraphs || []).map((paragraph) => (
        <p key={paragraph.slice(0, 48)}>{paragraph}</p>
      ))}
      {section.list?.length > 0 && (
        <ul>
          {section.list.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </section>
  );
}

function PageBreadcrumb({ label }) {
  return (
    <div className="breadcrumb">
      <Link to="/">Home</Link>
      <span>/</span>
      <span>{label}</span>
    </div>
  );
}

export default function InfoPage({ pageId }) {
  const page = getLegalPage(pageId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageId]);

  if (!page) {
    return (
      <PageShell>
        <p className="status-text error page-status container">Page not found.</p>
      </PageShell>
    );
  }

  return (
    <PageShell>
      <Seo title={page.title} description={page.description} />

      <section className={`section legal-section${page.showForm ? ' legal-section-contact' : ''}`}>
        {page.showForm ? (
          <div className="container contact-panel">
            <article className="contact-copy">
              <PageBreadcrumb label={page.h1} />
              <h1>{page.h1}</h1>
              {page.intro && <p className="legal-intro">{page.intro}</p>}
              {(page.sections || []).map((section) => (
                <LegalSection key={section.heading} section={section} />
              ))}
            </article>

            <div className="contact-form">
              <LeadForm
                title={page.formTitle}
                subtitle={page.formSubtitle}
                leadSource={`${pageId}_form`}
              />
            </div>
          </div>
        ) : (
          <div className="container legal-prose">
            <article className="legal-article">
              <PageBreadcrumb label={page.h1} />
              <h1>{page.h1}</h1>
              {page.updated && <p className="legal-updated">Last updated {page.updated}</p>}
              {page.intro && <p className="legal-intro">{page.intro}</p>}
              {(page.sections || []).map((section) => (
                <LegalSection key={section.heading} section={section} />
              ))}
              {page.cta && (
                <p className="legal-cta">
                  <Link to={page.cta.to} className="cta-button">
                    {page.cta.label}
                  </Link>
                </p>
              )}
            </article>
          </div>
        )}
      </section>
    </PageShell>
  );
}
